export default {
  methods: {
    getOrderedFilterCollection(collection,
                               keys,
                               keyReceiver = (item) => { return _.get(item, 'id') },
                               order = 'display_order') {


      console.log("Получаем коллекцию для ID:", keys, "Исходная коллекция:", collection);
      keys = !_.isArray(keys) ? [keys] : keys;
      let needItems = _.filter(collection, (item) => {
        return keys.indexOf(keyReceiver(item)) !== -1;
      });

      return _.sortBy(needItems, order);
    },

    getAliasesFromCollection(collection, column = 'alias') {
      console.log("Обрабатываем коллекцию для alias:", collection);
      let aliases = [];
      _.forEach(collection, (item) => {
        aliases.push(_.get(item, column));
      });

      return aliases;
    },

    getBooleanAliasesFromCollection(collection, column = 'alias') {
      let aliasResult = null;

      _.forEach(collection, (item) => {
        const alias = _.get(item, column);

        // Если alias равен "true" или "false", всегда перезаписываем aliasResult
        if (alias === "true" || alias === "false") {
          aliasResult = alias;
        }
      });

      // Возвращаем массив с одним значением (либо "true", либо "false")
      return aliasResult !== null ? [aliasResult] : [];
    },

    buildRoute(orderFilters, routes, forPagination = false) {
      let historyState = [];
      _.forEach(orderFilters, (item) => {
        let route = _.get(routes, item);
        let aliases = [];
        if(_.isArray(route)) {
          console.log('buildRoute for item=', item, ' => route=', route);
          if (item === 'languages' && this.defaultLanguage) {
            aliases = _.map(_.filter(route, (r) => r !== document.documentElement.getAttribute('lang')), (alias) => {
              return this.aliasToRoute(alias);
            });
          } else {
            aliases = _.map(route, (alias) => {
              return this.aliasToRoute(alias);
            });
          }
        } else if(item === 'page') {
          if (route > 1 && !forPagination) { // Skip page number when building route for pagination
            aliases.push(route);
          }
        } else if(_.isNumber(route) && route !== 0) {
          aliases.push(this.aliasToRoute(route));
        } else if(!_.isEmpty(route)) {
          aliases.push(this.aliasToRoute(route));
        }

        if(!_.isEmpty(aliases))
          historyState.push(item + '=' + aliases.join('-'));
      });

      return historyState.join('/');
    },

    aliasToRoute(alias) {
      return _.isString(alias) ? alias.replace(/\-/g, '_') : alias;
    },

    changeRoute(route, rootPathname) {
      const url = new URL(rootPathname);
      if(window.history && history.pushState) {
        url.pathname += (_.isEmpty(route) ? '' : '/') + route;
        this.changeWindowHistory(url.href, '', 'Excursion Search');
      }
    },
  }
}
